import { render } from "./PromotionsSection.vue?vue&type=template&id=e77db66e"
import script from "./PromotionsSection.vue?vue&type=script&lang=js"
export * from "./PromotionsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.20_vue@3.5.20_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__